import React from "react";
import { Check } from "lucide-react";
import { useSiteContent } from "../data/content";

export default function Profile() {
  const content = useSiteContent();
  const { profil, images } = content;
  return (
    <section id="profil" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden ring-1 ring-slate-200 shadow-xl shadow-slate-900/5">
              <img
                src={images.about}
                alt={profil.title}
                className="w-full h-[520px] object-cover"
              />
            </div>
            <div className="absolute -right-4 -bottom-4 sm:-right-8 sm:-bottom-8 bg-[#0B1F3A] text-white rounded-2xl p-6 w-[220px] shadow-2xl">
              <div className="text-4xl font-semibold tracking-tight">{profil.badgeYears}</div>
              <div className="text-sm text-slate-300 mt-1">{profil.badgeLabel}</div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2">
          <span className="text-[12px] font-medium tracking-[0.2em] uppercase text-teal-700">
            {profil.eyebrow}
          </span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-semibold tracking-[-0.02em] text-[#0B1F3A] leading-[1.1]">
            {profil.title}
          </h2>
          {profil.paragraphs.map((p, i) => (
            <p key={i} className="mt-6 text-slate-600 text-[17px] leading-relaxed">
              {p}
            </p>
          ))}
          <div className="mt-10 grid sm:grid-cols-2 gap-3 max-w-xl">
            {profil.highlights.map((h) => (
              <div
                key={h}
                className="flex items-center gap-3 bg-slate-50 border border-slate-100 rounded-lg px-4 py-3"
              >
                <span className="w-7 h-7 rounded-md bg-teal-100 text-teal-700 flex items-center justify-center">
                  <Check className="w-4 h-4" />
                </span>
                <span className="text-sm font-medium text-[#0B1F3A]">{h}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
